import { createQueryKeys } from '@lukemorales/query-key-factory';

export const uaeDashboard = createQueryKeys('uaeDashboard', {
  mine: null,
});
